import React from 'react';
import {Table, Input, Checkbox, Button, Dropdown} from 'semantic-ui-react';
import {warranties, PAYCODE_OPTIONS} from '../../../../constants';
import {parseTasksOptions} from '../../../../utils';

const FormWork = (props) => {
  const {
    taskId,
    flatDealer,
    principalTask,
    description,
    handleChange,
    paycode,
    handleAddItem,
    handleCheckBox,
    handleKeyDown,
    loading,
    flatTde,
    flatInternal,
    campaignTasks,
    campaignFlag,
    handleSelectionChange,
  } = props;
  const validateBtn = description === '';
  const total = (flatTde * warranties.hour_price).toFixed(2);
  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={loading}
          label='¿Es operación manual ?'
          checked={principalTask}
          onChange={handleCheckBox}
        />
      </Table.Cell>
      <Table.Cell>
        {campaignFlag && campaignTasks && campaignTasks.length > 0 ? (
          <Dropdown
            selection
            search
            placeholder='No.Operación'
            options={parseTasksOptions(campaignTasks)}
            value={taskId}
            onChange={handleSelectionChange}
          />) :
          (<Input
            disabled={loading}
            className='twc-works-input'
            placeholder='No.Operación'
            value={taskId}
            onKeyDown={handleKeyDown}
            onChange={(e, {value}) => handleChange('taskId', value)}
          />)}
      </Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          value={flatDealer}
          type='number'
          placeholder='Flat Dealer'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('flatDealer', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          placeholder='Flat TDE'
          value={flatTde}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('flatTde', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          placeholder='Flat Internal'
          value={flatInternal}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('flatInternal', value)}
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {total}
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          selection
          placeholder='Paycode'
          value={paycode}
          options={PAYCODE_OPTIONS}
          onChange={(e, {value}) => handleChange('paycode', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color='green'
        >
          Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default FormWork;
